module.exports = __webpack_public_path__ + "static/raiku-5d58ff5848d68afa5dbd769c186a798e.svg";